import { TypedDocumentNode, gql } from "@apollo/client";

export const GET_REGION_WISE_COUNTRIES: TypedDocumentNode<{
  regionWiseCountries: {
    region: string;
    countries: {
      name: string;
      code_slug: string;
    }[];
  }[];
}> = gql`
  query GetRegionWiseCountries {
    regionWiseCountries {
      region
      countries {
        name
        code_slug
      }
    }
  }
`;
